import axios from './axios'

export const uploadCustomBackground = async (data) => {
  const response = await axios.post("/category/background-upload", data);
  return response.data;
};